import { render, staticRenderFns } from "./FacebookLoginButtonComponent.vue?vue&type=template&id=40ff6b1c&scoped=true&"
import script from "./FacebookLoginButtonComponent.vue?vue&type=script&lang=js&"
export * from "./FacebookLoginButtonComponent.vue?vue&type=script&lang=js&"
import style0 from "./FacebookLoginButtonComponent.vue?vue&type=style&index=0&id=40ff6b1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ff6b1c",
  null
  
)

export default component.exports